import { Box } from '@mui/material'

interface SharedTextSectionProps {
  shareText: string
}

export const SharedTextSection = ({ shareText }: SharedTextSectionProps) => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box
        sx={{
          p: 2,
          borderRadius: 1,
          fontFamily: 'monospace',
          fontSize: '0.9rem',
          lineHeight: 1.6,
          color: 'text.primary',
          whiteSpace: 'pre-line',
          wordBreak: 'break-all',
        }}
      >
        {shareText}
      </Box>
    </Box>
  )
}
